/**
 * Marks the floating controls' interactive surfaces - the handle and the
 * stepper - so a modal focus trap drawn over the experience can keep them in
 * its tab ring. They render at app level, outside any dialog an experience
 * opens, yet stay operable while one is up: the fact detail wires their Back
 * to close it (SelectedFactDetail), and the stepper still moves between
 * sections. Without the marker a trap snaps focus away from them and three
 * visible, clickable buttons become unreachable by keyboard (DSC-10288).
 */
export const EXPERIENCE_NAV_CONTROL_ATTRIBUTE = 'data-experience-nav-control'

export const EXPERIENCE_NAV_CONTROL_SELECTOR = `[${EXPERIENCE_NAV_CONTROL_ATTRIBUTE}]`

/** Spread onto the element that is, or wraps, the control(s). */
export const experienceNavControlProps = { [EXPERIENCE_NAV_CONTROL_ATTRIBUTE]: '' }
